import CoverLink from "components/Cover/CoverLink";
import TextLink from "hardcover-ui/components/TextLink";
import ContributionsList from "components/authors/ContributionsList";
import { BookButton } from "features/BookButton";
import BookReview from "./BookReview";
import { UserBookSerializersUserBookReviewWithBook } from "types/serializers";

export default function BookReviewWithBook({
  review,
}: {
  review: UserBookSerializersUserBookReviewWithBook;
}) {
  return (
    <div className="flex lg:flex-row space-x-4 lg:space-x-8 py-4 w-full ">
      <div className="flex-none hidden lg:flex lg:flex-col items-center space-y-4">
        <CoverLink
          book={review.book}
          edition={review.edition}
          size="md"
          variant="secondary"
          className="flex-none"
          settings={{
            showStatus: true,
            tooltip: true,
            details: true,
            referrerId: review.userId,
          }}
        />

        <BookButton
          size="sm"
          bookId={review.bookId}
          referrerUserId={review.userId}
        />
      </div>
      <div className="grow">
        <div className="flex flex-row-reverse lg:flex-row items-center justify-end lg:justify-start">
          <div className="space-y-2">
            <p>
              <TextLink
                variant="title"
                underline={false}
                size="xl"
                href={`/books/${review.book.slug}`}
              >
                {review.edition ? review.edition.title : review.book.title}
              </TextLink>
            </p>
            <ContributionsList
              contributions={review.book.contributions}
              byLine
              avatar
              size="xs"
            />
          </div>
          <CoverLink
            book={review.book}
            edition={review.edition}
            size="xs"
            variant="secondary"
            className="lg:hidden mr-4 flex-none"
          />
        </div>

        <BookReview
          book={review.book}
          userBook={review}
          linkToReview
          showUser={false}
          className="pt-4"
        />
      </div>
    </div>
  );
}
